import { FeatureFlag } from '../FeatureFlag';

export const enableKeyboardCommands = new FeatureFlag({
    key: 'enable-keyboard-commands',
    defaultValue: false,
});
